/**
 * AddChannelSetCtrl controller
 *
 * @class AddChannelSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin*
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddChannelSetCtrl
 */
/* @ngInject */

export default function ContentSetsModalCtrl ($uibModalInstance, cs, item, checkIntersection) {
  const vm = this
  vm.openFooter = window.innerHeight > 750
  vm.cs = cs
  vm.item = item
  vm.contentTypes = {
    channel: 'Channel',
    tv_show: 'TV Show',
    live_event: 'Live Event',
    vod: 'VOD',
    SEASON: 'Season',
    EPISODE: 'Episode'
  }

  vm.type = vm.contentTypes[cs.$setType]
  vm.itemNmae = item.name

  vm.checkIntersection = function () {
    checkIntersection()
      .then(() => {
        if (!vm.item.conflicts) {
          $uibModalInstance.dismiss()
        }
      })
  }

  vm.close = $uibModalInstance.dismiss
}
